export const FETCH_GEOFENCES_SUCCESS = 'fetch_geofences_success'
export const CREATE_OR_UPDATE_GEOFENCE_SUCCESS = 'create_or_update_geofence_success'
export const CREATE_GEOFENCE_SUCCESS = 'create_geofence_success'
export const UPDATE_GEOFENCE_SUCCESS = 'update_geofence_success'
export const DELETE_GEOFENCE_SUCCESS = 'delete_geofence_success'
